<template>
  <div class="p-5">
    <div class="container-fluid">
      <div class="row size-column">
        <div class="col-xxl-12 col-md-12 box-col-12 grid-ed-12">
          <h6 class="mb-4">
            <b>Last Updated: </b><span style="color: #03c04a">{{ formattedLastUpdated
            }}<i v-if="last_updated" class="ml-1 fa fa-light fa-check-circle-o" style="color: #03c04a"></i></span>
          </h6>
          <h2 class="fw-bold">Hamburger Menu (HM)</h2>
          <p>Edit your menu below and don't forget to save your changes</p>
          <div class="appointment">
            <h4 class="fw-bold">Add Items</h4>

            <div class="row gap-4">
              <div class="col-md-4 card">
                <div class="card-header">
                  <div class="header-top">
                    <h5 class="m-0 fw-bold">Pages</h5>
                  </div>
                </div>
                <div class="card-body">
                  <p>The maximum amount of selection is 4 items.</p>
                  <div class="pages-list">
                    <div v-for="(pages, index) in pages" :key="index" class="col">
                      <label class="checkbox-row">
                        <input type="checkbox" v-model="pages.checked" :disabled="customizedMenu.length + selectedMenuCount >= 4 &&
                          !pages.checked
                          " />
                        {{ pages.name }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="card-footer border-none d-flex justify-content-end">
                  <div>
                    <PrimaryButton @click="addToMenu">+</PrimaryButton>
                  </div>
                </div>
              </div>

              <div class="col-md-7 card">
                <div class="card-header">
                  <div class="header-top">
                    <h5 class="m-0 fw-bold">Structure</h5>

                    <PrimaryButton :disabled="false" @click="save()">
                      Save
                    </PrimaryButton>
                  </div>
                </div>
                <div class="card-body pt-0">
                  <div class="my-2 structure"></div>
                  <p>
                    The menu location above is where you can make edits. The
                    fries will open a single page menu, as shown below. Add and
                    drag items in the preferred order.
                  </p>

                  <div class="col-md-12 d-flex mt-3 gap-4">
                    <div class="col-md-6 fries">
                      <div class="input-row">
                        <draggable :key="columnIndex" :list="customizedMenu" group="menuItems">
                          <template v-slot:item="{ element, index }">
                            <div class="menu-item">
                              <span class="index-number">{{
                                getMenuIndex(columnIndex, index)
                              }}</span>
                              {{ element.name }}
                              <button @click="removeInput(element.id)" class="remove-button">
                                x
                              </button>
                            </div>
                          </template>
                        </draggable>
                      </div>
                    </div>
                    <div class="col-md-6 d-flex align-items-end">
                      <div class="">
                        <div style="display: flex; flex-direction: column">
                          <div style="
                              display: flex;
                              flex-direction: row;
                              align-items: center;
                            ">
                            <img :src="this.image
                              ? this.image
                              : require('@/assets/images/empty.jpg')
                              " style="
                                width: 120px;
                                height: 120px;
                                object-fit: contain;
                                border-radius: 10px;
                                border: dashed 1px gray;
                              " />
                            <div class="fileUpload bg-none text-left align-middle d-block">
                              <div>
                                <span class="media-text p-2">Select from Media Library (Max dimension 1200
                                  x 800 px)</span>
                              </div>
                              <button @click="openGalleryModal('friesIcon')" aria-hidden="true"
                                class="mx-2 p-2 border w-auto">
                                Upload File
                              </button>
                            </div>
                          </div>
                        </div>
                        <div>
                          <img src="@/assets/images/admin/header/HM_FriesIcon.svg" alt="" style="width: 10rem" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <ImageComponent @add-image="handleAddImage($event)" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/PrimaryButton.vue";
import FileUploadComponent from "@/components/FileUploadComponent.vue";
import draggable from "vuedraggable";
import { getRequest, patchRequest } from "@/services/RequestService";
import { ref, computed, onMounted } from "vue";
import ImageComponent from "@/components/ImageComponent.vue";
import axios from "axios";

export default {
  components: {
    PrimaryButton,
    FileUploadComponent,
    draggable,
    ImageComponent,
  },

  data() {
    return {
      customizedMenu: [],
      image: "",
      last_updated: "",
      groupedItemsArr: [],
      dragging: false,
    };
  },
  computed: {
    formattedLastUpdated() {
      const date = new Date(this.last_updated);
      const day = date.getDate();
      const month = date.getMonth() + 1; // Months are 0-indexed
      const year = date.getFullYear();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const ampm = hours >= 12 ? "pm" : "am";
      return `${day}/${month}/${year}, ${hours % 12}:${minutes} ${ampm}`;
    },

    groupedMenuItems() {
      const maxItemsPerColumn = 4;
      const groupedItems = [];
      let currentColumn = [];

      this.customizedMenu.forEach((menu, index) => {
        if (index > 0 && index % maxItemsPerColumn === 0) {
          groupedItems.push(currentColumn);
          currentColumn = [];
        }
        currentColumn.push(menu);
      });

      if (currentColumn.length > 0) {
        groupedItems.push(currentColumn);
      }

      this.customizedMenu = groupedItems;

      return customizedMenu;
    },
  },
  setup() {
    const pages = ref([]);

    const loadMenus = async () => {
      try {
        let response = await getRequest("/pages", true);

        if (response.data && response.data.data) {
          pages.value = response.data.data;

          // Initialize the 'checked' property for each menu item
          pages.value.forEach((page) => {
            page.checked = false;
          });
        } else {
          console.error("API response is missing data:", response);
        }
      } catch (error) {
        console.error("Error fetching API data:", error);
      }
    };

    const selectedMenuCount = computed(() => {
      return pages.value.filter((page) => page.checked).length;
    });

    onMounted(loadMenus);

    onMounted(() => {
      selectedMenuCount.value; // This line ensures that the computed property is properly initialized on component mount
    });

    return {
      pages,
      selectedMenuCount,
    };
  },
  methods: {
    loadMenuImg() {
      axios.get("/headers/2/view").then((response) => {
        this.last_updated = response.data.data.updated_at;
        this.image = response.data.data.image_url;
        this.image_id = response.data.data.image_id;

        // Extract menu items from the 'menus' array in the API response
        const menuItems = response.data.data.menus;

        // Map the menu items to the format expected in customizedMenu
        this.customizedMenu = menuItems.map((menuItem) => {
          return {
            id: menuItem.id,
            name: menuItem.name,
            // Add other properties as needed
          };
        });

      })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },

    addToMenu() {
      const selectedMenus = this.pages.filter((pages) => pages.checked);

      // Calculate the number of items already in the customized menu
      const existingItemsCount = this.customizedMenu.length;
      const remainingSlots = 4 - existingItemsCount; // Update to match the max limit

      // Add selected items to the customized menu if they're not already present
      selectedMenus.forEach((menu) => {
        if (
          this.customizedMenu.length < 4 &&
          !this.customizedMenu.includes(menu)
        ) {
          this.customizedMenu.push(menu);
        }
      });

      // Enable checkboxes if needed
      if (this.customizedMenu.length + this.selectedMenuCount < 4) {
        this.pages.forEach((pages) => {
          pages.checked = false;
        });
      }
    },

    removeInput(id) {
      const removedIndex = this.customizedMenu.findIndex(
        (pages) => pages.id === id
      );
      if (removedIndex !== -1) {
        this.customizedMenu.splice(removedIndex, 1);
      }

      // Enable checkboxes if needed
      if (this.customizedMenu.length + this.selectedMenuCount < 4) {
        this.pages.forEach((pages) => {
          pages.checked = false;
        });
      }
    },

    handleDragChange(evt) {
      const newGroupedMenuItems = [];
      for (const column of evt) {
        newGroupedMenuItems.push(column.map((item) => item));
      }
      this.groupedMenuItems = newGroupedMenuItems;
    },

    getMenuIndex(columnIndex, itemIndex) {
      let index = 0;
      for (let i = 0; i < columnIndex; i++) {
        index += this.groupedMenuItems[i].length;
      }
      return index + itemIndex + 1;
    },

    openGalleryModal(section) {
      console.log("Open Gallery for:", section);

      document.getElementById("modal_id").value = section;

      var galleryModal = document.getElementById("galleryModal");
      galleryModal.classList.add("show");
      galleryModal.style.display = "block";
    },

    handleAddImage(galleryId) {
      console.log(
        "Added image with ID:",
        galleryId,
        "For Section:",
        galleryId.modalName
      );

      this.image = galleryId.galleryUrl;
      this.image_id = galleryId.galleryId;
    },

    async save() {
      try {
        let post_request = this._headerRequest();

        let response = await patchRequest("/headers/2/update", post_request);

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            location.reload();
          });
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }

        if (response.data.success === false) {
          throw new Error("Something's not right. Please try again.");
        }

        console.log(response.data);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    _headerRequest() {
      const menuIds = this.customizedMenu.map((menu) => menu.id);

      return {
        structure: menuIds,
        gallery_id: this.image_id,
      };
    },
  },

  mounted() {
    this.loadMenuImg();
  },
};
</script>

<style scoped>
.card-body {
  padding: 10px;
}

.pages-list {
  border: 1px solid #dadada;
  border-radius: 3%;
  padding: 10px;
}

.checkbox-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 10px;
  border: 1px solid #dadada;
  border-radius: 5px;
  background-color: #f5f5f5;
  box-sizing: border-box;
  width: 20rem;
  margin-bottom: 32px;
}

.index-number {
  display: inline-block;
  margin-right: 5px;
  font-weight: bold;
  color: #333;
}

.input-row {
  display: flex;
  align-items: center;
  translate: 46px 66px;
}

.order-number {
  margin-right: 10px;
}

.menu-list {
  margin-right: 10px;
  background-color: #dadada;
  border-radius: 10px;
  padding: 10px;
  width: 300px;
}

.remove-button {
  margin-left: auto;
  padding: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: none;
  font-weight: bold;
  cursor: pointer;
}

.add-button {
  margin-top: 10px;
}

.fries {
  background-image: url("@/assets/images/admin/header/HM_Fries BG.svg");
  background-size: cover;
  height: 25rem;
}
</style>
